module.exports = __webpack_public_path__ + "img/u320.558b0ffe.svg";